import React from 'react'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { connect } from 'react-redux'

import ExportToExcelWithColor from './ExportToExcelWithColor'

function ExportExcelFile({ proposals, proposalsOrdered, users }) {
  const claudiaData = users.find(
    user => user.id === '8CV6naz7dDbVB89w0nRFwRwGkMR2'
  )
  const simoData = users.find(
    user => user.id === 'PehPUNk0t3RyrQTO26EiuOYbxVI2'
  )
  function mergeObjects(array, key) {
    const res = array.reduce((acc, obj) => {
      let found = false
      for (let i = 0; i < acc.length; i++) {
        if (acc[i][key] === obj[key]) {
          found = true
          Object.assign(acc[i], obj)
        }
      }
      if (!found) {
        acc.push(obj)
      }
      return acc
    }, [])
    return res
  }

  const shapeExcelData = () => {
    let data = []

    const classColours = proposalsOrdered.reduce((acc, proposal) => {
      acc[proposal.id] = {
        text: proposal?.class?.class,
        fill: proposal?.class?.colour
      }
      return acc
    }, {})

    Object.entries(proposals).forEach(([id, proposal], index) => {
      const row = {
        No: proposal.number,
        'Ehdotuksen nimi': proposal.name,
        'Kaupunkikuvaan ja kaupunkirakenteeseen sovittaminen': {
          claudia:
            claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
              'kaupunkikuvaan_ja_kaupunkirakenteeseen_sovittaminen'
            ] || '',
          simo:
            simoData?.proposals?.[id]?.rateWithPlusOrMinus?.[
              'kaupunkikuvaan_ja_kaupunkirakenteeseen_sovittaminen'
            ] || ''
        },
        'Kokonaistaloudellisuus ja edellytykset elinkaaritavoitteiden täyttymiseen sekä ekologisuus': {
          claudia:
            claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
              'kokonaistaloudellisuus_ja_edellytykset_elinkaaritavoitteiden_täyttymiseen_sekä_ekologisuus'
            ] || '',
          simo:
            simoData?.proposals?.[id]?.rateWithPlusOrMinus?.[
              'kokonaistaloudellisuus_ja_edellytykset_elinkaaritavoitteiden_täyttymiseen_sekä_ekologisuus'
            ] || ''
        },
        'Kulttuurisen vetovoiman vahvistaminen': {
          claudia:
            claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
              'kulttuurisen_vetovoiman_vahvistaminen'
            ] || '',
          simo:
            simoData?.proposals?.[id]?.rateWithPlusOrMinus?.[
              'kulttuurisen_vetovoiman_vahvistaminen'
            ] || ''
        },
        'Arkkitehtoniset ja toiminnalliset ratkaisut': {
          claudia:
            claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
              'arkkitehtoniset_ja_toiminnalliset_ratkaisut'
            ] || '',
          simo:
            simoData?.proposals?.[id]?.rateWithPlusOrMinus?.[
              'arkkitehtoniset_ja_toiminnalliset_ratkaisut'
            ] || ''
        },
        Yleisarvio: claudiaData?.proposals?.[id]?.rate?.['overall'] || '',
        Class: classColours[id]?.text.toUpperCase() || '',
        'Class color': {
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
              argb: classColours[id]?.fill?.replace('#', '') || 'FFFFFF'
            }
          }
        }
      }

      data.push(row)
    })

    const groupedData = mergeObjects(data, 'No')

    return groupedData
  }

  const excelData = shapeExcelData()

  const generateWscols = () => {
    const columns = excelData[0]
      ? Object.keys(excelData[0]).map(key => {
          return {
            wch: key === 'Ehdotuksen nimi' ? 50 : key.length + 10
          }
        })
      : []

    return columns
  }

  const wscols = generateWscols()

  return (
    <div>
      <ExportToExcelWithColor
        excelData={excelData}
        fileName="File name"
        wscols={wscols}
        submissionDeadline=""
      />
    </div>
  )
}

const mapStateToProps = state => {
  return {
    // proposals: state.proposals,
    PublicClasses: state.firestore.ordered.PublicClasses,
    proposalsOrdered: state.firestore.ordered.proposals,
    users: state.firestore.ordered.users
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    { collection: 'proposals' },
    { collection: 'PublicClasses', orderBy: ['position', 'asc'] },
    { collection: 'users' }
  ])
)(ExportExcelFile)

// Object.entries(proposals).forEach(([id, proposal], index) => {
//   const row = {
//     No: proposal.number,
//     'Ehdotuksen nimi': proposal.name,
//     'Kaupunkikuvaan ja kaupunkirakenteeseen sovittaminen': {
//       text:
//         claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//           'kaupunkikuvaan_ja_kaupunkirakenteeseen_sovittaminen'
//         ] || '',
//       fill: {
//         type: 'pattern',
//         pattern: 'solid',
//         fgColor: {
//           argb:
//             claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//               'kaupunkikuvaan_ja_kaupunkirakenteeseen_sovittaminen'
//             ] === 'plus'
//               ? '00FF00'
//               : claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//                   'kaupunkikuvaan_ja_kaupunkirakenteeseen_sovittaminen'
//                 ] === 'minus'
//               ? 'FF0000'
//               : 'FFFFFF'
//         }
//       }
//     },
//     'Kokonaistaloudellisuus ja edellytykset elinkaaritavoitteiden täyttymiseen sekä ekologisuus': {
//       text:
//         claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//           'kokonaistaloudellisuus_ja_edellytykset_elinkaaritavoitteiden_täyttymiseen_sekä_ekologisuus'
//         ] || '',
//       fill: {
//         type: 'pattern',
//         pattern: 'solid',
//         fgColor: {
//           argb:
//             claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//               'kokonaistaloudellisuus_ja_edellytykset_elinkaaritavoitteiden_täyttymiseen_sekä_ekologisuus'
//             ] === 'plus'
//               ? '00FF00'
//               : claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//                   'kokonaistaloudellisuus_ja_edellytykset_elinkaaritavoitteiden_täyttymiseen_sekä_ekologisuus'
//                 ] === 'minus'
//               ? 'FF0000'
//               : 'FFFFFF'
//         }
//       }
//     },
//     'Kulttuurisen vetovoiman vahvistaminen': {
//       text:
//         claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//           'kulttuurisen_vetovoiman_vahvistaminen'
//         ] || '',
//       fill: {
//         type: 'pattern',
//         pattern: 'solid',
//         fgColor: {
//           argb:
//             claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//               'kulttuurisen_vetovoiman_vahvistaminen'
//             ] === 'plus'
//               ? '00FF00'
//               : claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//                   'kulttuurisen_vetovoiman_vahvistaminen'
//                 ] === 'minus'
//               ? 'FF0000'
//               : 'FFFFFF'
//         }
//       }
//     },
//     'Arkkitehtoniset ja toiminnalliset ratkaisut': {
//       text:
//         claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//           'arkkitehtoniset_ja_toiminnalliset_ratkaisut'
//         ] || '',
//       fill: {
//         type: 'pattern',
//         pattern: 'solid',
//         fgColor: {
//           argb:
//             claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//               'arkkitehtoniset_ja_toiminnalliset_ratkaisut'
//             ] === 'plus'
//               ? '00FF00'
//               : claudiaData?.proposals?.[id]?.rateWithPlusOrMinus?.[
//                   'arkkitehtoniset_ja_toiminnalliset_ratkaisut'
//                 ] === 'minus'
//               ? 'FF0000'
//               : 'FFFFFF'
//         }
//       }
//     },
//     Yleisarvio: claudiaData?.proposals?.[id]?.rate?.['overall'] || '',
//     Class: {
//       text: classColours[id]?.text.toUpperCase() || '',
//       fill: {
//         type: 'pattern',
//         pattern: 'solid',
//         fgColor: {
//           argb: classColours[id]?.fill?.replace('#', '') || 'FFFFFF'
//         }
//       }
//     }
//   }

//   data.push(row)
// })
